import { camelCase, mapKeys } from 'lodash-es';

// most props from the checkout_app_props method in Ruby come through in snake case
export const buildInitialCheckoutState = (overrides) => {
  const stateSnakeCase = {
    duration: 'yearly',
    checkoutSubmitting: false,
    checkoutSuccess: false,
    checkoutError: null,
    hideTerms: false,
    isStudentPromotion: false,
    isHolidayPromotion: false,
    isTrial: false,
    promoCodeSubmitting: false,
    promoCodeError: false,
    promoCodeInputVisibility: false,
    products: null,
    ...overrides
  };
  // map top-level state keys to camelCase
  return mapKeys(stateSnakeCase, (val, key) => camelCase(key));
};

export default { buildInitialCheckoutState };
